import { useEffect } from 'react';

import { useStoreContext } from 'features/store';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { logger } from 'utils/logger';

import { PosVendor } from '../../../generated/graphql-gateway';

const LOG_DELAY_MS = 100;
const logTimeoutId = { current: null };
export const isMessageLogged = { current: false };

export const useMinimalCartUi = () => {
  const enableMinimalCartUiFlag = useFlag(LaunchDarklyFlag.ENABLE_MINIMAL_CART_UI);
  const { store } = useStoreContext();
  const posVendor = store?.pos?.vendor.toLowerCase();
  const isPosVendorBrink = posVendor === PosVendor.BRINK.toLowerCase();

  const enableMinimalCartUi = enableMinimalCartUiFlag && isPosVendorBrink;
  useEffect(() => {
    if (isMessageLogged.current) {
      return;
    }

    // Wait for deps (flag + store/vendor) to settle before logging to avoid false negatives
    if (!posVendor) {
      return;
    }

    if (logTimeoutId.current) {
      clearTimeout(logTimeoutId.current);
    }

    logTimeoutId.current = setTimeout(() => {
      logger.debug({
        message: `Minimal cart UI ${enableMinimalCartUi ? 'enabled' : 'disabled'}`,
        enableMinimalCartUi,
        enableMinimalCartUiFlag,
        posVendor,
        storeId: store?.number,
      });
      isMessageLogged.current = true;
    }, LOG_DELAY_MS);

    return () => {
      if (logTimeoutId.current) {
        clearTimeout(logTimeoutId.current);
      }
    };
  }, [enableMinimalCartUi, enableMinimalCartUiFlag, posVendor, store?.number]);

  return enableMinimalCartUi && isPosVendorBrink;
};
